import { FC, useState } from "react"
import { StyleUtils } from "../../../utils/Style"
import { AppEvent } from "../../../data/events"
import events, { useEventBus } from "../../../utils/events"
import { UserInfoManager } from "../../../utils/UserInfoManager"
import { NeptuneGuidePage } from "./NeptuneGuidePage";
import { AleoGuidePage } from "./AleoGuidePage";

export const GuidePage: FC = () => {
    const [changeStyle, setChangeStyle] = useState(true)

    events.on(AppEvent.ChangeStyle, (changeType: string) => {
        setChangeStyle(!changeStyle)
    })
    useEventBus(AppEvent.REFRES, (changeType: string) => {
        setChangeStyle(!changeStyle)
    })

    return (
        <>
        {
          UserInfoManager.currency === "aleo" ? <AleoGuidePage /> : <NeptuneGuidePage  />
        }
        </>
    )
}